import { Button as ButtonMui, CircularProgress } from '@mui/material';
import classNames from 'classnames';

import { RoundedButtonProps } from './interface';

const RoundedButton = ({
  color,
  disabled,
  children,
  loading,
  'data-testid': dataTestId,
  additionalHeight,
  ...props
}: RoundedButtonProps): JSX.Element => {
  return (
    <div
      className={classNames(
        `flex items-center rounded-[4rem] border px-4 text-white shadow-md
        ${additionalHeight ? additionalHeight : 'h-8'}
        `,
        {
          'bg-[var(--bluon--default--blue-3)]':
            color === 'primary' && !disabled,
          'bg-[var(--bluon--white)]': color === 'secondary' && !disabled,
          'bg-[var(--bluon--ds--lightgray-3)]':
            color === 'neutral' && !disabled,
          'bg-[var(--bluon--light--gray-12)]': disabled,
        },
      )}
    >
      <ButtonMui
        {...props}
        disabled={disabled}
        data-testid={dataTestId}
        variant='text'
        color={
          color === 'neutral'
            ? 'neutral'
            : color !== 'secondary'
            ? 'primaryLight'
            : 'primary'
        }
      >
        {loading ? (
          <CircularProgress
            size='small'
            className='bl-button-loader'
            data-testid={dataTestId}
          />
        ) : (
          children
        )}
      </ButtonMui>
    </div>
  );
};

export default RoundedButton;
